import React from 'react';
import { motion } from 'framer-motion';
import { Video, MessageSquare, Users, Target, ShieldCheck } from 'lucide-react';
export function LiveClasses() {
  return <section className="py-24 bg-ed-dark relative overflow-hidden" data-id="element-269">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-270">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-271">
          {/* Left: Visual */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative order-2 lg:order-1" data-id="element-272">
            <div className="aspect-video bg-ed-black rounded-2xl border border-zinc-800 shadow-2xl overflow-hidden relative flex flex-col" data-id="element-273">
              {/* Top bar */}
              <div className="h-10 bg-zinc-900 border-b border-zinc-800 flex items-center px-4 justify-between" data-id="element-274">
                <div className="flex items-center gap-2" data-id="element-275">
                  <span className="relative flex h-2.5 w-2.5" data-id="element-276">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" data-id="element-277"></span>
                    <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500" data-id="element-278"></span>
                  </span>
                  <span className="text-xs font-bold text-zinc-300 uppercase tracking-wider" data-id="element-279">
                    En Vivo
                  </span>
                </div>
                <div className="flex gap-1.5" data-id="element-280">
                  <div className="w-2.5 h-2.5 rounded-full bg-zinc-700" data-id="element-281"></div>
                  <div className="w-2.5 h-2.5 rounded-full bg-zinc-700" data-id="element-282"></div>
                  <div className="w-2.5 h-2.5 rounded-full bg-zinc-700" data-id="element-283"></div>
                </div>
              </div>

              {/* Video Area — real Zoom class screenshot */}
              <div className="flex-grow relative bg-black overflow-hidden" data-id="element-284">
                <img src="https://cdn.magicpatterns.com/uploads/2FsFeNoELCER5ySTkbG3C8/ChatGPT_Image_5_jun_2026,_19_25_34.png" alt="Clase en vivo de la Academia ED por videollamada con alumnos de toda Argentina" className="w-full h-full object-cover object-center select-none" data-id="element-285" />
              </div>
            </div>

            {/* Ambient glow behind video */}
            <div className="absolute inset-0 bg-ed-green/10 blur-[100px] -z-10" data-id="element-286"></div>
          </motion.div>

          {/* Right: Copy */}
          <div className="order-1 lg:order-2" data-id="element-287">
            <span className="text-ed-green font-bold tracking-widest uppercase text-sm mb-3 block" data-id="element-288">
              Clases en vivo
            </span>
            <h2 className="text-4xl sm:text-5xl font-black uppercase tracking-tight text-white mb-6" data-id="element-289">
              No aprendés solo.
            </h2>
            <p className="text-lg text-zinc-400 mb-8 font-medium" data-id="element-290">
              Clases en vivo con un docente real que responde tus preguntas,
              corrige tu trabajo y te acompaña en todo el proceso.
            </p>

            <ul className="space-y-4 mb-10" data-id="element-291">
              {[{
              icon: MessageSquare,
              text: 'Preguntas en tiempo real'
            }, {
              icon: Target,
              text: 'Análisis de casos reales'
            }, {
              icon: Users,
              text: 'Interacción directa'
            }, {
              icon: ShieldCheck,
              text: 'Correcciones personalizadas'
            }, {
              icon: Video,
              text: 'Acompañamiento continuo'
            }].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-292">
                  <div className="w-8 h-8 rounded-lg bg-ed-black border border-zinc-800 flex items-center justify-center shrink-0" data-id="element-293">
                    <item.icon className="w-4 h-4 text-ed-green" data-id="element-294" />
                  </div>
                  <span className="text-zinc-200 font-medium" data-id="element-295">{item.text}</span>
                </li>)}
            </ul>

            <div className="inline-block relative" data-id="element-296">
              <div className="absolute inset-0 bg-ed-green/20 blur-xl" data-id="element-297"></div>
              <div className="relative bg-ed-black border border-ed-green/50 rounded-xl p-5" data-id="element-298">
                <p className="text-xl font-black text-white uppercase tracking-wide" data-id="element-299">
                  No es un curso grabado{' '}
                  <span className="text-ed-green underline decoration-ed-green decoration-4 underline-offset-4" data-id="element-300">
                    abandonado.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}